import React from "react";
import "./Spinner.css"; // you can define the styles in a separate css file

const Spinner = () => {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
};

export default Spinner;
